// Hardcoded Combo Shop dataset.
// Every field here traces to an actual cell in the internal product
// spreadsheet (COMBINATION sheet for combo-level numbers; Master
// Product List / Dinnerware - Kintsugi sheets for each individual
// product's brand, net quantity, manufacturer, address, and story).
// Nothing here is composed/invented copy — no combo has a marketing
// blurb in the sheet, so none is shown; the row instead lists the
// two included product names as plain chips.
//
// IMPORTANT: place the two images for each combo at
//   src/assets/images/combo-products/<Combo_Name_With_Underscores>_1.<ext>
//   src/assets/images/combo-products/<Combo_Name_With_Underscores>_2.<ext>
// before building — these are static imports, so a missing/misnamed
// file will fail the build (check extension + no stray spaces).

import theLuminaryDuet1 from "@/assets/images/combo-products/The_Luminary_Duet_1.png";
import theLuminaryDuet2 from "@/assets/images/combo-products/The_Luminary_Duet_2.jpeg";
import aureateStarSet1 from "@/assets/images/combo-products/Aureate_Star_Set_1.png";
import aureateStarSet2 from "@/assets/images/combo-products/Aureate_Star_Set_2.jpeg";
import imperialOpulenceCollection1 from "@/assets/images/combo-products/Imperial_Opulence_Collection_1.png";
import imperialOpulenceCollection2 from "@/assets/images/combo-products/Imperial_Opulence_Collection_2.jpeg";
import fabiusRoyalAssortment1 from "@/assets/images/combo-products/Fabius_Royal_Assortment_1.png";
import fabiusRoyalAssortment2 from "@/assets/images/combo-products/Fabius_Royal_Assortment_2.jpeg";

// Combo-level pricing has exactly two tiers (no separate "distributor
// before first order" tier):
//   - customer: shown to guests and logged-in customers, CV hidden
//   - distributor: shown to any logged-in distributor, CV shown
export const COMBO_PRODUCTS = [
  {
    id: "COM-001",
    baCoupon: "DUET_BA",
    cCoupon: "DUET_C",
    slug: "the-luminary-duet",
    name: "The Luminary Duet",
    netQuantity: 2,
    cv: 1800,
    shippingAndHandling: 2300,
    images: [theLuminaryDuet1, theLuminaryDuet2],
    pricing: {
      customer: { price: 181420, mrp: 198420 },
      distributor: { price: 175780, mrp: 189730 },
    },
    products: [
      {
        sku: "1002610",
        productId: "1",
        name: "Amora",
        brand: "Carat Street",
        netQuantityLabel: "1 Piece Pendant",
        cv: 600,
        netPrice: 60240,
        shippingCharge: 800,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Amora1.jpeg",
        countryOfManufacture: "India",
        manufacturedBy: "KGK Creation India Private Limited",
        manufacturerAddress:
          "KGK Tower, 5th Floor, Dutta Pada Road, Near Ekta Bhoomi Garden, Borivali East, Mumbai – 400066",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          "The Amora Pendant features a modern horizontal bar design with a subtle bridge of light. A sleek, gracefully arched bar of polished 18K gold cradles a horizontal row of graduated diamonds. The minimalist linear setting allows the stones to take center stage, creating a subtle, floating curve of light that rests perfectly along the natural contour of the collarbone. A reflection of modern minimal luxury, engineered for effortless daily wear.",
      },
      {
        sku: "2002611",
        productId: "20",
        name: "Spectrum Luxe",
        brand: "Kintsugi",
        netQuantityLabel: "47 Piece Dinner & Tea Set",
        cv: 1200,
        netPrice: 138180,
        shippingCharge: 1500,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Spectrum+Luxe2.jpeg",
        countryOfManufacture: "India",
        manufacturedBy: "Umberto Ceramics International Private Limited",
        manufacturerAddress:
          "Sadoliya - Galteshwar Road, Off. N H 8, Galesara, Prantij, Gujarat 383205, India",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          "A Bold Symphony of Modern Art. A thrilling departure from traditional motifs, the Spectrum Luxe collection is a celebration of avant-garde geometry and vibrant energy. The rim of each piece features a breathtaking, stained-glass-inspired mosaic of vivid, modern hues — expertly structured and framed by brilliant 24-karat gold plating. This expansive 47-piece set spans from the main course to the final cup of tea, bridging the gap between bold contemporary design and impeccable Indian manufacturing. It is the ultimate collection for the modern aesthete who views their table as a gallery.",
      },
    ],
  },
  {
    id: "COM-002",
    baCoupon: "STAR_BA",
    cCoupon: "STAR_C",
    slug: "aureate-star-set",
    name: "Aureate Star Set",
    netQuantity: 2,
    cv: 1800,
    shippingAndHandling: 2300,
    images: [aureateStarSet1, aureateStarSet2],
    pricing: {
      customer: { price: 188000, mrp: 204667 },
      distributor: { price: 182360, mrp: 197437 },
    },
    products: [
      {
        sku: "1002614",
        productId: "4",
        name: "Tara",
        brand: "Carat Street",
        netQuantityLabel: "1 Piece Pendant",
        cv: 1200,
        netPrice: 123163,
        shippingCharge: 750,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Tara1.jpeg",
        countryOfManufacture: "India",
        manufacturedBy: "KGK Creation India Private Limited",
        manufacturerAddress:
          "KGK Tower, 5th Floor, Dutta Pada Road, Near Ekta Bhoomi Garden, Borivali East, Mumbai – 400066",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          "Inspired by the upward motion of a flickering flame, the Tara Pendant features a starburst spray of 18K yellow gold and diamonds. Dynamic strands of polished gold burst outward and upward in an energetic sweep, each ribbon tipping off with a luminous diamond accent. The asymmetrical, flared layering creates a sense of joyful, upward momentum, making the piece feel alive and full of spirited motion.",
      },
      {
        sku: "2002615",
        productId: "17",
        name: "Aureate Gold",
        brand: "Kintsugi",
        netQuantityLabel: "20 Piece Dinner Set",
        cv: 600,
        netPrice: 69635,
        shippingCharge: 1500,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Aureate+Gold1.png",
        countryOfManufacture: "India",
        manufacturedBy: "Umberto Ceramics International Private Limited",
        manufacturerAddress:
          "Sadoliya - Galteshwar Road, Off. N H 8, Galesara, Prantij, Gujarat 383205, India",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          "The Art of Radiant Hospitality. Inspired by the warmth of a royal sunset, the Aureate Gold collection brings a touch of majestic elegance to intimate gatherings. Crafted from pristine, bone-ash-free fine porcelain in our state-of-the-art kilns, each piece features a striking ruby-toned border illuminated by intricate, mandala-inspired floral motifs. Hand-finished with luxurious 24-karat gold plating, this 20-piece ensemble seamlessly blends vibrant Indian heritage with global 5-star dining standards, ensuring every meal feels like a celebration of light and life.",
      },
    ],
  },
  {
    id: "COM-003",
    baCoupon: "OPULENCE_BA",
    cCoupon: "OPULENCE_C",
    slug: "imperial-opulence-collection",
    name: "Imperial Opulence Collection",
    netQuantity: 2,
    cv: 2400,
    shippingAndHandling: 2300,
    images: [imperialOpulenceCollection1, imperialOpulenceCollection2],
    pricing: {
      customer: { price: 239700, mrp: 253095 },
      distributor: { price: 232180, mrp: 241730 },
    },
    products: [
      {
        sku: "1002611",
        productId: "2",
        name: "Maya",
        brand: "Carat Street",
        netQuantityLabel: "1 Piece Pendant",
        cv: 600,
        netPrice: 56550,
        shippingCharge: 750,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Maya1.jpeg",
        countryOfManufacture: "India",
        manufacturedBy: "KGK Creation India Private Limited",
        manufacturerAddress:
          "KGK Tower, 5th Floor, Dutta Pada Road, Near Ekta Bhoomi Garden, Borivali East, Mumbai – 400066",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          "Inspired by the simple beauty of a blooming flower, the Maya Pendant features a classic diamond cluster. Carefully matched diamonds form a perfect floral halo around a gleaming central stone, set within subtle 18K gold prongs that enhance their unified sparkle. The compact, domed arrangement ensures every facet catches the light, delivering an intense, singular flash of brilliance from every angle.",
      },
      {
        sku: "2002610",
        productId: "21",
        name: "Royal Opulence",
        brand: "Kintsugi",
        netQuantityLabel: "54 Piece Dinner Set",
        cv: 1800,
        netPrice: 183300,
        shippingCharge: 1500,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Royal+Opulence3.jpeg",
        countryOfManufacture: "India",
        manufacturedBy: "Umberto Ceramics International Private Limited",
        manufacturerAddress:
          "Sadoliya - Galteshwar Road, Off. N H 8, Galesara, Prantij, Gujarat 383205, India",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          'The Ultimate Expression of Dining Luxury. The crowning jewel of our porcelain house, Royal Opulence is a breathtaking 54-piece collection engineered for life\'s most extravagant celebrations. Its deep, striking turquoise borders are heavily encrusted with classical 24-karat gold paisley and baroque motifs, reflecting the unrivaled luxury of imperial banquets. With every conceivable piece included — from soup bowls to beautifully crafted serving platters and pickle jars — this bone-ash-free collection represents the absolute zenith of "Made in India" mastery. An heirloom-quality set designed to leave a lasting legacy on your family table.',
      },
    ],
  },
  {
    id: "COM-004",
    baCoupon: "ROYAL_BA",
    cCoupon: "ROYAL_C",
    slug: "fabius-royal-assortment",
    name: "Fabius Royal Assortment",
    netQuantity: 2,
    cv: 3000,
    shippingAndHandling: 2300,
    images: [fabiusRoyalAssortment1, fabiusRoyalAssortment2],
    pricing: {
      customer: { price: 282000, mrp: 307944 },
      distributor: { price: 270720, mrp: 293280 },
    },
    products: [
      {
        sku: "2002610",
        productId: "21",
        name: "Royal Opulence",
        brand: "Kintsugi",
        netQuantityLabel: "54 Piece Dinner Set",
        cv: 1800,
        netPrice: 183300,
        shippingCharge: 1500,
        image:
          "https://sme-product-image-ecom-uat.s3.ap-south-1.amazonaws.com/product/images/Royal+Opulence3.jpeg",
        countryOfManufacture: "India",
        manufacturedBy: "Umberto Ceramics International Private Limited",
        manufacturerAddress:
          "Sadoliya - Galteshwar Road, Off. N H 8, Galesara, Prantij, Gujarat 383205, India",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          'The Ultimate Expression of Dining Luxury. The crowning jewel of our porcelain house, Royal Opulence is a breathtaking 54-piece collection engineered for life\'s most extravagant celebrations. Its deep, striking turquoise borders are heavily encrusted with classical 24-karat gold paisley and baroque motifs, reflecting the unrivaled luxury of imperial banquets. With every conceivable piece included — from soup bowls to beautifully crafted serving platters and pickle jars — this bone-ash-free collection represents the absolute zenith of "Made in India" mastery. An heirloom-quality set designed to leave a lasting legacy on your family table.',
      },
      {
        sku: "5002610",
        productId: "25",
        name: "Fabius Resolute — Black",
        brand: "Fabius",
        netQuantityLabel: "1 No.",
        cv: 1200,
        netPrice: 109980,
        shippingCharge: 750,
        image:
          "https://ecom-uat-image.s3.ap-south-1.amazonaws.com/IMG_1779.png",
        countryOfManufacture: "India",
        manufacturedBy: "Lecorb India Private Limited",
        manufacturerAddress:
          "Lecorb India Private Limited, Plot 41A Sector 1, Parwanoo, Solan, Himachal Pradesh",
        marketedBy: "INDIEKONNECT ENTERPRISES PVT LTD",
        story:
          "A tribute to architectural strength and precision engineering, the Fabius Resolute Black strips away the superfluous to reveal the beating heart within. The see-through skeleton dial and exhibition caseback expose the enduring, rhythmic dance of its automatic mechanics, protected by scratch-resistant flat sapphire crystal. Framed in a bold 42mm stainless steel case and paired with a premium textured black leather strap, this timepiece reflects an unwavering mindset and a strong core. Engineered for the modern man who thrives under pressure.",
      },
    ],
  },
];

// Same role-detection logic as ProductDetailView.vue, kept identical so
// combo pricing and single-product pricing never disagree about who
// counts as a "distributor".
function normalizeRoleToken(value) {
  return String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function getUserRoleToken() {
  try {
    const rawAuth = window.localStorage.getItem("auth.currentUser");
    const authPayload = rawAuth ? JSON.parse(rawAuth) : {};
    const user = authPayload?.data || authPayload || {};
    const roleCandidates = [
      user?.userType,
      user?.role,
      user?.loginRole,
      user?.customerType,
    ]
      .map(normalizeRoleToken)
      .filter(Boolean);

    return roleCandidates[0] || "";
  } catch (error) {
    return "";
  }
}

export function getUserFirstOrderCompleted() {
  try {
    const rawAuth = window.localStorage.getItem("auth.currentUser");
    const authPayload = rawAuth ? JSON.parse(rawAuth) : {};
    const user = authPayload?.data || authPayload || {};
    const value = user?.firstOrderCompleted;

    return (
      value === true ||
      value === 1 ||
      String(value || "")
        .trim()
        .toLowerCase() === "true"
    );
  } catch (error) {
    return false;
  }
}

export function isDistributorRole(roleToken) {
  return roleToken === "DISTRIBUTOR";
}

// Returns { price, mrp, showMrp, showCv } for a combo given the current
// role token (pass getUserRoleToken() from the component).
export function getComboPriceInfo(
  combo,
  roleToken,
  firstOrderCompleted = false,
) {
  const isEligibleDistributor =
    isDistributorRole(roleToken) && firstOrderCompleted;
  const tier = isEligibleDistributor ? "distributor" : "customer";
  const { price, mrp } = combo.pricing[tier];

  return {
    price,
    mrp,
    showMrp: mrp !== price,
    showCv: isEligibleDistributor,
  };
}

export function getCouponInfo(combo, roleToken, firstOrderCompleted = false) {
  const isEligibleDistributor =
    isDistributorRole(roleToken) && firstOrderCompleted;
  return isEligibleDistributor ? combo.baCoupon : combo.cCoupon;
}

export function formatRs(value) {
  if (value === undefined || value === null || value === "") return "N/A";
  const formatted = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  }).format(value);
  return `₹${formatted}`;
}

/* ------------------------------------------------------------------ *
 * CART-SIDE DISCOUNT HELPERS
 *
 * Refresh-cart is the source of truth for discount names and amounts.
 * Do not resolve discounts against the static combo catalogue here: the
 * backend can return identifiers and messages that are not in that catalogue.
 * ------------------------------------------------------------------ */

const round2 = (value) =>
  Math.round((Number(value) + Number.EPSILON) * 100) / 100;

// Discount info for one cart line, or null when the API returned no usable
// discount for that line.
//   { entries: [{ comboId, name, discountId, amount }],
//     amount,          // total discount on this line
//     netPrice,        // what the customer pays for the line
//     originalPrice }  // netPrice + amount (the pre-discount price)
export function getItemComboInfo(item) {
  const list = Array.isArray(item?.discounts) ? item.discounts : [];

  const entries = list
    .map((discount) => {
      const amount = Number(discount?.discountAmount);
      const name = String(discount?.discountMessage || "").trim();
      if (!name || !Number.isFinite(amount) || amount <= 0) return null;
      return {
        comboId: name,
        name,
        discountId: String(discount.id || `${name}-${item?.key || ""}`),
        amount: round2(amount),
      };
    })
    .filter(Boolean);

  if (!entries.length) return null;

  const netPrice = Number(item?.price ?? item?.netPrice);
  const safeNet = Number.isFinite(netPrice) ? netPrice : 0;
  const amount = round2(entries.reduce((sum, entry) => sum + entry.amount, 0));

  return {
    entries,
    amount,
    netPrice: round2(safeNet),
    originalPrice: round2(safeNet + amount),
  };
}

// Cart-level roll-up used by the Subtotal section.
//   { totalDiscount, combos: [{ comboId, name, amount, netAmount }] }
export function getCartComboSummary(items) {
  const byCombo = new Map();

  (Array.isArray(items) ? items : []).forEach((item) => {
    const info = getItemComboInfo(item);
    if (!info) return;

    info.entries.forEach((entry) => {
      const row = byCombo.get(entry.comboId) || {
        comboId: entry.comboId,
        name: entry.name,
        amount: 0,
        netAmount: 0,
      };
      row.amount += entry.amount;
      if (info.entries.length === 1) row.netAmount += info.netPrice;
      byCombo.set(entry.comboId, row);
    });
  });

  const combos = [...byCombo.values()].map((row) => {
    return {
      comboId: row.comboId,
      name: row.name,
      amount: round2(row.amount),
      netAmount: round2(row.netAmount),
    };
  });

  return {
    totalDiscount: round2(combos.reduce((sum, row) => sum + row.amount, 0)),
    combos,
  };
}
